<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <Card :title="'Catat Darah Keluar'">
          <template v-slot:body>
            <Form :form="form" :route="'donor-recipients'" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Form from '@/component/donor-recipients/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      form: {
        patient_id: null,
        name: "",
        blood_type_id: null,
        age: null,
        birt_date: null,
        receipt_date: window.medhopToday(),
        phone: "",
        gender: null,
        quantity: 1,
        email: "",
        id_card_number: null,
        address: "",
      }
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bank Darah", route: "/blood-bank" },
      { title: "Riwayat Transaksi", route: "/blood-bank/history" },
      { title: "Darah Keluar" },
    ])
  },

}
</script>

<style>
</style>
